import React from 'react';
import { HeaderSection, HeaderTitle, HeaderSpan, HeaderControls } from '../../MetricPanel/styled';
import EventsControl from '../control';

const Header = () => {
  return (
    <HeaderSection>
      <HeaderTitle>
        Events
        <HeaderSpan>Beta</HeaderSpan>
      </HeaderTitle>
      <HeaderControls>
        <EventsControl />
      </HeaderControls>
    </HeaderSection>
  );
};

export default Header;
